"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const icarros_colors = {
    yellow_icarros: {
        color_yellowIcarros_20: '##FFD83A',
        color_yellowIcarros_40: '##F8B508',
    },
    purple_icarros: {
        color_purpleIcarros_50: '#5731FF',
        color_purpleIcarros_70: '#2F10BB',
        color_purpleIcarros_soft: '#106EB01A',
    },
    orange_icarros: {
        color_orangeIcarros_20: '#FD9D00',
        color_orangeIcarros_40: '#FF7500',
        color_orangeIcarros_50: '#EC7000',
        color_orangeIcarros_60: '#DD6100',
        color_orangeIcarros_70: '#C04500',
    },
    turquoise_cold: {
        color_turquoiseCold_20: '#DBFCF3',
        color_turquoiseCold_40: '#8CD1BF',
    },
    green_light: {
        color_greenLight_40: '#059C4B',
    },
    green_olive: {
        color_greenOlive_50: '#059C4B',
    },
    red_alert: {
        color_redAlert_50: '#C60000',
        color_redAlert_70: '#990000',
    },
    sand: {
        color_sand_10: '#FAF7F5',
        color_sand_20: '#EFE9E5',
        color_sand_30: '#D6D0CC',
        color_sand_50: '#89837F',
        color_sand_70: '#706A66',
        color_sand_80: '#56504C',
        color_sand_90: '#231D19',
    },
};
exports.default = icarros_colors;
//# sourceMappingURL=icarros.js.map